import React from "react";
import { useSelector } from "react-redux";
import {
  MessageItem,
  MessageItemContainer,
  TimeContainer,
  Message,
  SenderHeader,
} from "./style";
import { timeFormatterUI } from "../../../utils/helpers/dataHelper";

export default function ChatItem({ item }) {
  // console.log("item ===> ", item)
  const profile = useSelector(({ profileReducer }) => profileReducer);
  const matricNumber = profile.userData.matricNumber;
  const user = item.senderMatricNumber === matricNumber ? "ME" : "";
  const time = timeFormatterUI(item.timestamp);
  return (
    <MessageItemContainer user={user}>
      <MessageItem user={user}>
        <>
          <Message user={user}>
            <SenderHeader user={user}>{item.senderName}</SenderHeader>
            {item.message}
          </Message>
          <TimeContainer>{time}</TimeContainer>
        </>
      </MessageItem>
    </MessageItemContainer>
  );
}
